module.exports = __webpack_public_path__ + "img/d3b5537b519a3dcfec33b88a3bd4d403.png";